import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true,
  timeout: 30000,
  transformRequest:
    [(data) => {
    // Transform the data from js object to form data
      const formData = new FormData()
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key])
      })
      return formData
    }]
})

// request interceptor
service.interceptors.request.use(
  config => {
    // if (store.getters.token) {
    //   // let each request carry token
    //   // ['X-Token'] is a custom headers key
    //   // please modify it according to the actual situation
    //   config.headers['X-Token'] = getToken()
    // }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  response => {
    const res = response
    // download file
    // if (!response.headers['content-type'].includes('application/json')) {
    //  return res
    // }

    // if the custom code is not 20000, it is judged as an error.
    if (res.status !== 200) {
      return Promise.reject(new Error(res.data.message))
    } else {
      return Promise.resolve(res)
    }
  },
  error => {
    console.log(error)
    if (typeof error.response === 'undefined') {
      console.log('網路錯誤')
      return Promise.reject(new Error('發生網路上的錯誤，請確定網路連線正常。'))
    }
    return Promise.reject(error)
  }
)

interface RetryCallback {
  (value: AxiosResponse<any>): boolean
}

export async function retryRequest (config: AxiosRequestConfig, retryCondition: RetryCallback = () => { return false }, retryCount = 0): Promise<AxiosResponse<any>> {
  try {
    await delay(1000)
    const response = await service(config)
    if (retryCount >= 4) {
      return response
    }
    if (retryCondition(response)) {
      return retryRequest(config, retryCondition, retryCount + 1)
    } else return response
  } catch (error) {
    if (retryCount >= 4) {
      return Promise.reject(error)
    } else { return retryRequest(config, retryCondition, retryCount + 1) }
  }
}

async function delay (ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export default service
